import * as ExchangeRefundPriceDetails from './ExchangeRefundPriceDetails.css';
import * as PriceItem from './components/PriceItem/PriceItem.css';
import * as Details from './components/Details/Details.css';
import * as ShortDetails from './components/ShortDetails/ShortDetails.css';
import * as TotalRefund from './components/TotalRefund/TotalRefund.css';
export default {
    PriceItem,
    Details,
    ShortDetails,
    TotalRefund,
    ExchangeRefundPriceDetails
};
